import { render, staticRenderFns } from "./PlaylistHeroItem.vue?vue&type=template&id=8a04d8ba"
import script from "./PlaylistHeroItem.vue?vue&type=script&lang=js"
export * from "./PlaylistHeroItem.vue?vue&type=script&lang=js"
import style0 from "./PlaylistHeroItem.vue?vue&type=style&index=0&id=8a04d8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports